import React from 'react';

function ExperienceCard({ job }) {
    const { jobtitle, company, startYear, endYear, summary, highlights = [] } = job;
    const period = [startYear, endYear].filter(Boolean).join(' – ');

    return (
        <>
            <p className='experience__period'>{period}</p>
            <div className='experience__main'>
                <h3>{jobtitle}</h3>
                <p className='experience__company'>{company}</p>
                {summary && <p className='experience__summary'>{summary}</p>}
                {highlights.length > 0 && (
                    <ul className='experience__highlights'>
                        {highlights.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                )}
            </div>
        </>
    );
}

export default ExperienceCard;
